import { render, staticRenderFns } from "./addCollections.vue?vue&type=template&id=0c6b7779"
import script from "./addCollections.vue?vue&type=script&lang=js"
export * from "./addCollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports